module.exports = __webpack_public_path__ + "img/owner_green.6dcdecb6.svg";